import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { DraftManagerService } from './draft-manager.service';

@Injectable({
  providedIn: 'root'
})
export class DraftSelectService {

  /** @var {BehaviorSubject} Source of all picks and bans */
  public selectionSource = new BehaviorSubject<{}>([]);
  /** @var An object containing all picked and banned champions by players */
  public selection = this.selectionSource.asObservable();

  constructor(
    private draftManagerService: DraftManagerService
  ) {
    // Set selection to null upon service instantiation.
    this.reset();
    // Subscribe to manager
    this.draftManagerService.phaseObservable.subscribe((phase: {}) => {
      if (this.draftManagerService.phaseNum != -1) {
        this.reset();
        this.select(phase['component']);
      }
    });
  }

  reset() {
    this.selectionSource.next([]);
  }

  select(item: any) {
    if (this.draftManagerService.draftType === "free") {
      let selection = this.selectionSource["_value"];
      selection.push(item);
      selection = this.evaluateSelection(selection);
      this.selectionSource.next(selection);
    }
    else if (this.draftManagerService.draftType === "pro") {
      let selection = this.selectionSource["_value"];
      if (item.getClassName() !== "ChampionListMemberComponent") {
        selection.push(item);
      }
      else {
        selection[1] = item;
        selection[0].champion = item.id;
      }
      this.selectionSource.next(selection);
    }
  }

  isSelected(element: any) {
    if (this.selectionSource["_value"].indexOf(element) > -1)
      return true;
    else
      return false;
  }

  evaluateSelection(selection: any[]) {
    if (selection.length === 1) {
      return selection;
    }
    else if (selection.length === 2) {
      if (
        selection[0] === selection[1]
      ) return [];
      else if (
        selection[0].getClassName() === "ChampionListMemberComponent" && selection[1].getClassName() === "ChampionListMemberComponent"
      ) return this.replaceFirstSelection(selection);
      else if (
        selection[0].getClassName() === "ChampionListMemberComponent" && selection[1].getClassName() === "DraftPlayerComponent" ||
        selection[1].getClassName() === "ChampionListMemberComponent" && selection[0].getClassName() === "DraftPlayerComponent"
      ) return this.lockChampionAsPick(selection);
      else if (
        selection[0].getClassName() === "ChampionListMemberComponent" && selection[1].getClassName() === "ChampionBanComponent" ||
        selection[1].getClassName() === "ChampionListMemberComponent" && selection[0].getClassName() === "ChampionBanComponent"
      ) return this.lockChampionAsBan(selection);
      else if (
        (selection[0].getClassName() === "DraftPlayerComponent" || selection[0].getClassName() === "ChampionBanComponent") &&
        (selection[1].getClassName() === "DraftPlayerComponent" || selection[1].getClassName() === "ChampionBanComponent")
      ) return this.switchChampions(selection);
    }
  }

  replaceFirstSelection(selection: any[]) {
    selection[0] = selection[1];
    selection.pop();
    return selection;
  }

  lockChampionAsPick(selection: any[]) {
    if (selection[0].getClassName() === "ChampionListMemberComponent")
      this.draftManagerService.setDraft("picks", selection[1].player, selection[0].id);
    else
      this.draftManagerService.setDraft("picks", selection[0].player, selection[1].id);
    return [];
  }

  lockChampionAsBan(selection: any[]) {
    if (selection[0].getClassName() === "ChampionListMemberComponent")
      this.draftManagerService.setDraft("bans", selection[1].player, selection[0].id);
    else
      this.draftManagerService.setDraft("bans", selection[0].player, selection[1].id);
    return [];
  }
 
  switchChampions(selection: any[]) {
    if (selection[0].champion === null && selection[1].champion === null)
      return this.replaceFirstSelection(selection);
    let champions = [selection[0].champion, selection[1].champion];
    let type = ["picks", "picks"];
    if (selection[0].getClassName() === "ChampionBanComponent")
      type[0] = "bans";
    if (selection[1].getClassName() === "ChampionBanComponent")
      type[1] = "bans";
    this.draftManagerService.setDraft(type[0], selection[0].player, champions[1]);
    this.draftManagerService.setDraft(type[1], selection[1].player, champions[0]);
    selection = [];
    return selection;
  }

}
